import { ReactNode } from 'react';
import { Lightbulb, AlertCircle, AlertTriangle, Info } from 'lucide-react';

type CalloutType = 'tip' | 'warning' | 'critical' | 'note';

const styles: Record<CalloutType, { bg: string; border: string; icon: any; color: string; title: string }> = {
  tip: { bg: 'bg-[#ECFDF5]', border: 'border-l-[#10B981]', icon: Lightbulb, color: 'text-[#059669]', title: 'TIP' },
  warning: { bg: 'bg-[#FFFBEB]', border: 'border-l-[#F59E0B]', icon: AlertCircle, color: 'text-[#D97706]', title: 'WARNING' },
  critical: { bg: 'bg-[#FEF2F2]', border: 'border-l-[#EF4444]', icon: AlertTriangle, color: 'text-[#DC2626]', title: 'CRITICAL' },
  note: { bg: 'bg-[#EFF6FF]', border: 'border-l-[#3B82F6]', icon: Info, color: 'text-[#2563EB]', title: 'NOTE' },
};

interface CalloutProps {
  type: CalloutType;
  children: ReactNode;
}

export default function Callout({ type, children }: CalloutProps) {
  const s = styles[type];
  const Icon = s.icon;

  return (
    <div className={`${s.bg} border-l-4 ${s.border} p-4 rounded-r-lg mb-5`}>
      <div className="flex items-center gap-2 mb-1.5">
        <Icon size={18} className={s.color} />
        <span className={`font-bold ${s.color} text-[13px] tracking-wide`}>{s.title}</span>
      </div>
      <div className="text-content-primary text-sm leading-relaxed">{children}</div>
    </div>
  );
}
